import CTNTabNavigation from '@ctn/ui/components/ctn-tab-navigation';
import { useState } from 'react';

import DatosJuridica from './form/DatosJuridica';
import Direccion from './form/Direccion';
import TabRepresentante from './TabRepresentante';

const TAB_ID = {
	juridica: 'juridica',
	representantes: 'representantes',
} as const;

type TabValue = (typeof TAB_ID)[keyof typeof TAB_ID];

type PersonaJuridicaProps = {
	readonly setDisableActions: (value: boolean) => void;
	readonly className?: string;
	readonly classNameRepresentante?: string;
	readonly isDisabled?: boolean;
};

const PersonaJuridica = ({ setDisableActions, className, classNameRepresentante, isDisabled }: PersonaJuridicaProps) => {
	const [activeTab, setActiveTab] = useState<TabValue>(TAB_ID.juridica);
	const isJuridica = activeTab === TAB_ID.juridica;
	const isRepresentantes = activeTab === TAB_ID.representantes;

	return (
		<>
			<CTNTabNavigation
				className={className}
				activeTab={activeTab}
				tabs={[
					{
						key: 'juridica',
						header: 'Datos de la persona jurídica',
						icon: [{ icon: 'realstateLine', position: 'left' }],
					},
					{
						key: 'representantes',
						header: 'Datos de los representantes',
						icon: [{ icon: 'userRepresentante', position: 'left' }],
					},
				]}
				onTabChange={({ index }) => setActiveTab(index as TabValue)}
			/>
			{isJuridica && (
				<>
					<DatosJuridica title="Datos de la persona" className="u-mt-24" isDisabled={isDisabled} />
					<Direccion title="Dirección de la persona" isDisabled={isDisabled} className="u-mt-16" />
				</>
			)}
			{isRepresentantes && <TabRepresentante className={classNameRepresentante} isDisabled={isDisabled} setDisableActions={setDisableActions} />}
		</>
	);
};

export default PersonaJuridica;
